import { render, staticRenderFns } from "./HoldingsDetails.vue?vue&type=template&id=3e514ab6"
import script from "./HoldingsDetails.vue?vue&type=script&lang=js"
export * from "./HoldingsDetails.vue?vue&type=script&lang=js"
import style0 from "./HoldingsDetails.vue?vue&type=style&index=0&id=3e514ab6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports